import {useEffect, useState, useRef} from 'react';
import { useNavigate } from 'react-router-dom';
import app, { db } from '../../../firebase';
import { collection, getDoc, getDocs, doc, setDoc, deleteField, updateDoc, } from "firebase/firestore";
import {deleteObject} from "firebase/compat/storage"

import {ImBin} from "react-icons/im"

import styles from "./RecentDesigns.module.css"

import { useAuth } from '../../../contexts/authContext';

import placeholder from "./placeholder.png"

const uuid = require("uuid")

export default function RecentDesigns() {
  const [allDesigns, setAllDesigns] = useState([])
  const [creatingDesign, setCreatingDesign] = useState(false);

  const designNameRef = useRef();

  const navigate = useNavigate()

  const {currentUser} = useAuth()

  
  async function getAllDesigns() {
    const querySnapshot = await getDocs(collection(db, "users"));
    // const querySnapshot = await getDocs(collection(db, "users"));

    const designs = [];
    
    querySnapshot.forEach(async (doc) => {
      if (doc.id === currentUser.uid) {
        const data = doc.data().allDesigns;
  
        for (let i = 0; i < Object.keys(data).length; i++) {
          const keys = Object.keys(data);
    
          const currentData = data[keys[i]];
    
          designs.push(
            <div key={currentData.id}>
              <button className={styles.recentDesignButton} onClick={() => {navigate(`/design?t&designId=${currentData.id}`)}}>
                <button className={styles.deleteDesignBtn} onClick={(e) => deleteDesign(e, currentData.id)}><ImBin /></button>
                <div style={{borderRadius: `${currentData.bgBorderRadius}px`}} className={styles.recentDesign}><img src={currentData.thumbnailUrl || placeholder} alt="" /></div>
              </button>

              <p className={styles.designName}>{currentData.designName}</p>
            </div>
          );
        }
      }
    })

    setAllDesigns(designs)
  }

  async function deleteDesign(e, designId) {
    e.stopPropagation();

    const userRef = doc(db, "users", currentUser.uid);
    const userSnapshot = await getDoc(userRef)
    const userDesigns = userSnapshot.data().allDesigns

    userDesigns[designId].imgSrc && app.storage().refFromURL(userDesigns[designId].imgSrc).delete();
    userDesigns[designId].thumbnailUrl && app.storage().refFromURL(userDesigns[designId].thumbnailUrl).delete();

    const obj = {};

    obj.allDesigns = {};
    obj.allDesigns[designId] = deleteField();

    await setDoc(userRef, obj, {merge:true});

    getAllDesigns()
  }

  async function createDesign(e) {
    e.preventDefault()

    const id = uuid.v4()
    const obj = {};

    obj.allDesigns = {}

    // ["#EEE4b4", "#A165D2"]

    obj.allDesigns[id] = {
      designName: designNameRef.current.value,
      neverLoaded: true,
      bgBorderRadius: "5",
      bgGradientColor: null,
      bgGradientRotation: 45,
      bgPadding: "95",
      bgTopPadding: "95",
      bgLeftPadding: "95",
      bgBottomPadding: "95",
      bgRightPadding: "95",
      bgLinkedPadding: true,
      bgSolidColor: null,
      bgType: "solid",
      id,
      imgBorderRadius: "5",
      // imgSrc: "https://cdn.dribbble.com/users/2151039/screenshots/17397767/media/dac1c58f1c5195fefb4623d9bef64d48.jpg?compress=1",
      imgSrc: null,
      imgWidth: "test",
      thumbnailUrl: null,
      imgShadow: {
        enabled: "off",
        blurRadius: "15",
        color: "#000000",
        opacity: "30",
        xOffset: "-20",
        yOffset: "-20"
      }
    }

    // await setDoc(doc(db, "allDesigns", currentUser.uid), obj, {merge:true});
    await setDoc(doc(db, "users", currentUser.uid), obj, {merge:true});
    // await setDoc(doc(db, "users", currentUser.uid), obj, {merge:true});
    // if (docSnap.exists()) {
    //   console.log("Document data:", docSnap.data());

    // } else {
    //   console.log("No such document!");
    // }

    navigate(`/design?t&designId=${id}`)
  }

  useEffect(() => {
    getAllDesigns()
  }, [])

  return (
    <div className={styles.recentDesigns}>
      <h2>Your Designs</h2>

      <div className={styles.recentDesignsContainer} id="recentDesignsContainer">
        <div>
          <button className={`${styles.createDesign} ${styles.recentDesignButton}`} onClick={() => {setCreatingDesign(!creatingDesign)}}>+</button>

          <p className={styles.designName}>Create Design</p>
        </div>

        {creatingDesign && 
          <div className={styles.designInfo}>
            <form onSubmit={createDesign}>
              <label htmlFor="designName">Name</label>
              <input type="text" id="designName" placeholder="Design Name" ref={designNameRef} />

              <button type="submit">Create</button>
            </form>
          </div>
        }

        {allDesigns}
      </div>
    </div>
  );
}
